var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "toolbar",
        { attrs: { title: "Load Board" } },
        [
          _c("v-icon", { on: { click: _vm.filterResults } }, [
            _vm._v("refresh")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", "justify-center": "" } },
            [
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "400" },
                  model: {
                    value: _vm.showTruckingInfoPrompt,
                    callback: function($$v) {
                      _vm.showTruckingInfoPrompt = $$v
                    },
                    expression: "showTruckingInfoPrompt"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", { staticClass: "headline" }, [
                        _vm._v(
                          "\n            Before placing bids, please add trucking information to your company profile.\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.companies, function(companyObject) {
                        return _vm.companies
                          ? _c(
                              "div",
                              { key: companyObject.id },
                              [
                                !_vm._.get(
                                  companyObject,
                                  "producerInfo.billingAddress.city",
                                  false
                                )
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          "align-center": "",
                                          color: "gray"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.$router.push({
                                              path:
                                                "/companies/" +
                                                companyObject.id +
                                                "/profile"
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { left: "" } }, [
                                          _vm._v("business")
                                        ]),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(companyObject.companyName) +
                                            " Company Profile\n              "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", flat: "flat" },
                              on: {
                                click: function($event) {
                                  _vm.showTruckingInfoPrompt = false
                                }
                              }
                            },
                            [_vm._v("\n              Close\n            ")]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.searchSuggestions.length
            ? _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: { value: true, color: "primary", type: "info" }
                        },
                        [
                          _vm._v(
                            "\n          Sorry, no results were found with those search criteria.\n          Maybe you will find one of these listings interesting...\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : !_vm.filteredResults.length && _vm.isMobile && !_vm.loadingResults
            ? _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: { value: true, color: "primary", type: "info" }
                        },
                        [
                          _vm._v(
                            "\n          No results at this time.\n          Be sure to subscribe to the\n          "
                          ),
                          _vm.signedIn
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "link ma-0 pa-0",
                                  attrs: { to: "notification-settings" }
                                },
                                [
                                  _vm._v(
                                    "\n            Loadboard notifications\n          "
                                  )
                                ]
                              )
                            : [_vm._v("Loadboard notifications")],
                          _vm._v(
                            " to hear when loads become available.\n          Be sure to select all of your interested states / regions.\n        "
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "mt-1" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "mx-2",
                      attrs: { xs12: "", md5: "", lg2: "" }
                    },
                    [
                      _c(
                        "v-menu",
                        {
                          ref: "dateMenu1",
                          attrs: {
                            "close-on-content-click": false,
                            "nudge-right": 40,
                            "return-value": _vm.sincePickupDateTime,
                            lazy: "",
                            transition: "scale-transition",
                            "offset-y": "",
                            "full-width": "",
                            "min-width": "290px"
                          },
                          on: {
                            "update:returnValue": function($event) {
                              _vm.sincePickupDateTime = $event
                            },
                            "update:return-value": function($event) {
                              _vm.sincePickupDateTime = $event
                            }
                          },
                          model: {
                            value: _vm.dateMenu1,
                            callback: function($$v) {
                              _vm.dateMenu1 = $$v
                            },
                            expression: "dateMenu1"
                          }
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              slot: "activator",
                              label: "Leaving on or After",
                              "prepend-icon": "event",
                              "append-icon": _vm.sincePickupDateTime
                                ? "close"
                                : "",
                              "append-icon-cb": function() {
                                _vm.sincePickupDateTime = null
                              },
                              readonly: ""
                            },
                            slot: "activator",
                            model: {
                              value: _vm.sincePickupDateTime,
                              callback: function($$v) {
                                _vm.sincePickupDateTime = $$v
                              },
                              expression: "sincePickupDateTime"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-date-picker",
                            {
                              attrs: { "no-title": "", scrollable: "" },
                              model: {
                                value: _vm.sincePickupDateTime,
                                callback: function($$v) {
                                  _vm.sincePickupDateTime = $$v
                                },
                                expression: "sincePickupDateTime"
                              }
                            },
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { flat: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.dateMenu1 = false
                                    }
                                  }
                                },
                                [_vm._v("Cancel")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { flat: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.dateMenu1.save(
                                        _vm.sincePickupDateTime
                                      )
                                    }
                                  }
                                },
                                [_vm._v("OK\n              ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "mx-2",
                      attrs: { xs12: "", md5: "", lg2: "" }
                    },
                    [
                      _c(
                        "v-menu",
                        {
                          ref: "dateMenu2",
                          attrs: {
                            "close-on-content-click": false,
                            "nudge-right": 40,
                            "return-value": _vm.untilPickupDateTime,
                            lazy: "",
                            transition: "scale-transition",
                            "offset-y": "",
                            "full-width": "",
                            "min-width": "290px"
                          },
                          on: {
                            "update:returnValue": function($event) {
                              _vm.untilPickupDateTime = $event
                            },
                            "update:return-value": function($event) {
                              _vm.untilPickupDateTime = $event
                            }
                          },
                          model: {
                            value: _vm.dateMenu2,
                            callback: function($$v) {
                              _vm.dateMenu2 = $$v
                            },
                            expression: "dateMenu2"
                          }
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              slot: "activator",
                              label: "Leaving on or Before",
                              "prepend-icon": "event",
                              "append-icon": _vm.untilPickupDateTime
                                ? "close"
                                : "",
                              "append-icon-cb": function() {
                                _vm.untilPickupDateTime = null
                              },
                              readonly: ""
                            },
                            slot: "activator",
                            model: {
                              value: _vm.untilPickupDateTime,
                              callback: function($$v) {
                                _vm.untilPickupDateTime = $$v
                              },
                              expression: "untilPickupDateTime"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-date-picker",
                            {
                              attrs: { "no-title": "", scrollable: "" },
                              model: {
                                value: _vm.untilPickupDateTime,
                                callback: function($$v) {
                                  _vm.untilPickupDateTime = $$v
                                },
                                expression: "untilPickupDateTime"
                              }
                            },
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { flat: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.dateMenu2 = false
                                    }
                                  }
                                },
                                [_vm._v("Cancel")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { flat: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.dateMenu2.save(
                                        _vm.untilPickupDateTime
                                      )
                                    }
                                  }
                                },
                                [_vm._v("\n                OK\n              ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "mx-2",
                      attrs: { xs12: "", md5: "", lg3: "" }
                    },
                    [
                      _c("address-search", {
                        attrs: {
                          label: "Leaving From",
                          currentLocationBtn: ""
                        },
                        on: { changeLocation: _vm.locationSearchChanged }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "mx-2",
                      attrs: { xs12: "", md5: "", lg2: "" }
                    },
                    [
                      _c("v-text-field", {
                        attrs: { clearable: "", label: _vm.radiusLabel },
                        model: {
                          value: _vm.radius,
                          callback: function($$v) {
                            _vm.radius = $$v
                          },
                          expression: "radius"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "mx-3",
                      attrs: { xs12: "", md5: "", lg1: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "outline clearable accent",
                          on: { click: _vm.search }
                        },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("search")
                          ]),
                          _vm._v("\n            Search\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isMobile
            ? _c(
                "v-layout",
                { staticClass: "mt-2", attrs: { sm12: "", column: "" } },
                _vm._l(_vm.filteredResults, function(load) {
                  return _c(
                    "v-card",
                    { key: load.id, staticClass: "xs12 my-2" },
                    [
                      _c(
                        "v-tabs",
                        [
                          _c("v-tab", { attrs: { ripple: "" } }, [
                            _vm._v(" Details ")
                          ]),
                          _vm._v(" "),
                          _c("v-tab", { attrs: { ripple: "" } }, [
                            _vm._v(" Bid ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            { key: 1 },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "mb-2",
                                      attrs: { column: "" }
                                    },
                                    [
                                      _vm.signedIn
                                        ? _c(
                                            "h2",
                                            [
                                              _c("CompanyName", {
                                                attrs: {
                                                  company: load.listingCompany
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _c("h4", { staticClass: "pb-2" }, [
                                            _c(
                                              "span",
                                              { staticClass: "font-italic" },
                                              [
                                                _vm._v(
                                                  "Register now to see load " +
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "booked-load.producers",
                                                          2
                                                        )
                                                        .toLocaleLowerCase()
                                                    )
                                                )
                                              ]
                                            )
                                          ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f(
                                                "pluralize"
                                              )(
                                                _vm.getVisibleCount(load),
                                                "load",
                                                { includeNumber: true }
                                              )
                                            ) +
                                            " still available.\n              "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("pluralize")(
                                                load.bids.placed,
                                                "bid",
                                                { includeNumber: true }
                                              )
                                            ) +
                                            " placed.\n                "
                                        ),
                                        load.bids.placed > 0
                                          ? _c("span", [
                                              _vm._v(
                                                "(Lowest bid: $" +
                                                  _vm._s(load.bids.minimumBid) +
                                                  ")"
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "" } },
                                    [
                                      _c("strong", [_vm._v("From: ")]),
                                      _vm._v(" "),
                                      _c("location-label", {
                                        attrs: { listing: load.from }
                                      }),
                                      _vm._v(" "),
                                      _c("strong", [_vm._v("To: ")]),
                                      _vm._v(" "),
                                      _c("location-label", {
                                        attrs: { listing: load.to }
                                      }),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "subheading" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-italic font-weight-light"
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.distanceLabel(
                                                    load.trip.loadedMiles
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  load.requirements.dispatchInstructions
                                    ? _c(
                                        "v-layout",
                                        {
                                          staticClass: "mb-2",
                                          attrs: { column: "" }
                                        },
                                        [
                                          _c("h4", [_vm._v("Instructions:")]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  load.requirements
                                                    .dispatchInstructions
                                                ) +
                                                "\n              "
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      load.requirements.requireWashout
                                        ? _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "25",
                                                height: "25",
                                                "icon-color": "#352208",
                                                "icon-name": "hose",
                                                tooltip: "Washout Required"
                                              }
                                            },
                                            [_c("icon-hose")],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      load.requirements.requireWeatherboards
                                        ? _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "25",
                                                height: "25",
                                                "icon-color": "#352208",
                                                "icon-name": "cold",
                                                tooltip:
                                                  "Weatherboards Required"
                                              }
                                            },
                                            [_c("icon-cold")],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      load.requirements.requireWoodChips
                                        ? _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "25",
                                                viewBox: "0 0 5 5",
                                                height: "25",
                                                "icon-name": "wood",
                                                "icon-color": "#352208",
                                                tooltip: "Wood Chips Required"
                                              }
                                            },
                                            [_c("icon-wood")],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("b", [_vm._v("Pickup Date:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatDate")(
                                          load.from.pickupWindow.pickupAt
                                        )
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("load-map", {
                                    attrs: {
                                      hideOnSmall: "",
                                      "disable-zoom": "",
                                      "origin-place-id": _vm._.get(
                                        load,
                                        "from.googlePlaceId",
                                        null
                                      ),
                                      "destination-place-id": _vm._.get(
                                        load,
                                        "to.googlePlaceId",
                                        null
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            { key: 2 },
                            [
                              _c("bid-form", {
                                attrs: {
                                  hideMapAndConversation: "",
                                  listing: load
                                },
                                on: { refresh: _vm.filterResults }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            : _c(
                "v-layout",
                { staticClass: "mt-2", attrs: { sm12: "", column: "" } },
                [
                  _c(
                    "v-data-table",
                    {
                      ref: "resultsTable",
                      staticClass: "elevation-1",
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.filteredResults,
                        expand: "",
                        loading: _vm.loadingResults,
                        "item-key": "listingHumanId",
                        "rows-per-page-items": [10, 20, 30]
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "headerCell",
                            fn: function(props) {
                              return [
                                _c("v-tooltip", { attrs: { bottom: "" } }, [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(props.header.text) +
                                          "\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(props.header.text) +
                                        "\n            "
                                    )
                                  ])
                                ])
                              ]
                            }
                          },
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    class: {
                                      "cursor-pointer": _vm.shouldShowRowExpandSlot(
                                        props.item
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.checkTruckingInfoBeforeDecidingToExpandRow(
                                          props.item,
                                          props.expanded
                                        )
                                          ? (props.expanded = !props.expanded)
                                          : null
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "id-col" },
                                      [
                                        _vm.shouldShowRowExpandSlot(props.item)
                                          ? [
                                              _c(
                                                "v-icon",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !props.expanded,
                                                      expression:
                                                        "!props.expanded"
                                                    }
                                                  ],
                                                  staticClass: "expand-icon"
                                                },
                                                [_vm._v("expand_more")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-icon",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: props.expanded,
                                                      expression:
                                                        "props.expanded"
                                                    }
                                                  ],
                                                  staticClass: "expand-icon"
                                                },
                                                [_vm._v("expand_less")]
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPlacedBid(props.item) &&
                                        _vm.hasAcceptedBid(props.item)
                                          ? _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  color: "green",
                                                  "text-color": "white"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Accepted\n                "
                                                ),
                                                _c(
                                                  "v-icon",
                                                  { attrs: { right: "" } },
                                                  [_vm._v("check_circle")]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm.hasPlacedBid(props.item)
                                          ? [
                                              _c(
                                                "v-btn",
                                                { attrs: { color: "accent" } },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        size: "18",
                                                        color: "white"
                                                      }
                                                    },
                                                    [_vm._v("edit")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "pl-2" },
                                                    [_vm._v("Modify Bid")]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          : _vm.isListingOwner(props.item)
                                          ? [
                                              _c(
                                                "v-btn",
                                                { attrs: { color: "accent" } },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        size: "18",
                                                        color: "white"
                                                      }
                                                    },
                                                    [_vm._v("visibility")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "pl-2",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.viewListingDetail(
                                                            props.item
                                                              .listingHumanId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  Modify Listing\n                "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          : [
                                              _c(
                                                "v-btn",
                                                { attrs: { color: "accent" } },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        size: "18",
                                                        color: "white"
                                                      }
                                                    },
                                                    [_vm._v("visibility")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.isLoadboardBiddingEnabled
                                                    ? _c(
                                                        "span",
                                                        { staticClass: "pl-2" },
                                                        [_vm._v("Place Bid")]
                                                      )
                                                    : _c(
                                                        "span",
                                                        { staticClass: "pl-2" },
                                                        [
                                                          _vm._v(
                                                            "Submit Availability"
                                                          )
                                                        ]
                                                      )
                                                ],
                                                1
                                              )
                                            ]
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm.signedIn
                                        ? _c(
                                            "span",
                                            [
                                              _c("CompanyName", {
                                                attrs: {
                                                  company:
                                                    props.item.listingCompany
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _c("span", [
                                            _vm._v("Log in to view company.")
                                          ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-left" },
                                      [
                                        _c(
                                          "v-flex",
                                          [
                                            _c("b", [_vm._v("From:")]),
                                            _vm._v(" "),
                                            _c("location-label", {
                                              attrs: {
                                                listing: props.item.from
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          [
                                            _c("b", [_vm._v("To:")]),
                                            _vm._v(" "),
                                            _c("location-label", {
                                              attrs: { listing: props.item.to }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm._f("formatDate")(
                                              props.item.from.pickupWindow
                                                .pickupAt
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-left" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.distanceLabel(
                                                props.item.trip.loadedMiles
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        props.item.requirements.requireWashout
                                          ? _c(
                                              "icon-base",
                                              {
                                                attrs: {
                                                  width: "25",
                                                  height: "25",
                                                  "icon-color": "#352208",
                                                  "icon-name": "hose",
                                                  tooltip: "Washout Required"
                                                }
                                              },
                                              [_c("icon-hose")],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        props.item.requirements
                                          .requireWeatherboards
                                          ? _c(
                                              "icon-base",
                                              {
                                                attrs: {
                                                  width: "25",
                                                  height: "25",
                                                  "icon-color": "#352208",
                                                  "icon-name": "cold",
                                                  tooltip:
                                                    "Weatherboards Required"
                                                }
                                              },
                                              [_c("icon-cold")],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        props.item.requirements.requireWoodChips
                                          ? _c(
                                              "icon-base",
                                              {
                                                attrs: {
                                                  width: "25",
                                                  viewBox: "0 0 5 5",
                                                  height: "25",
                                                  "icon-name": "wood",
                                                  "icon-color": "#352208",
                                                  tooltip: "Wood Chips Required"
                                                }
                                              },
                                              [_c("icon-wood")],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f(
                                                "pluralize"
                                              )(
                                                _vm.getVisibleCount(props.item),
                                                "load",
                                                { includeNumber: true }
                                              )
                                            ) +
                                            " still available.\n                "
                                        )
                                      ]),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("pluralize")(
                                                props.item.bids.placed,
                                                "bid",
                                                { includeNumber: true }
                                              )
                                            ) +
                                            " placed.\n                  "
                                        ),
                                        props.item.bids.placed > 0
                                          ? _c("span", [
                                              _vm._v(
                                                "(Lowest bid: $" +
                                                  _vm._s(
                                                    props.item.bids.minimumBid
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "expand",
                            fn: function(slotItems) {
                              return _vm.shouldShowRowExpandSlot(slotItems.item)
                                ? [
                                    _c(
                                      "v-card",
                                      { attrs: { "pl-4": "" } },
                                      [
                                        slotItems.item.requirements
                                          .dispatchInstructions
                                          ? _c(
                                              "v-card-text",
                                              { staticClass: "pt-1" },
                                              [
                                                _c("h4", [
                                                  _vm._v("Instructions: ")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        slotItems.item
                                                          .requirements
                                                          .dispatchInstructions
                                                      ) +
                                                      "\n              "
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("bid-form", {
                                          attrs: { listing: slotItems.item },
                                          on: { refresh: _vm.filterResults }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      !_vm.loadingResults
                        ? _c(
                            "template",
                            { slot: "no-data" },
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    value: true,
                                    color: "primary",
                                    type: "info"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            No results at this time.\n            Be sure to subscribe to the\n            "
                                  ),
                                  _vm.signedIn
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass: "link ma-0 pa-0",
                                          attrs: { to: "notification-settings" }
                                        },
                                        [
                                          _vm._v(
                                            "\n              Loadboard notifications\n            "
                                          )
                                        ]
                                      )
                                    : [_vm._v("Loadboard notifications")],
                                  _vm._v(
                                    "\n            to hear when loads become available.\n            Be sure to select all of your interested states / regions.\n          "
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25af0212", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25af0212","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoadBoards.vue
// module id = null
// module chunks = 